"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyField = exports.Textfield = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@stitches/react");
var react_currency_input_field_1 = __importDefault(require("react-currency-input-field"));
var stitches_config_1 = require("../stitches.config");
var Text_1 = require("./Text");
var StyledTexfieldInputCss = (0, stitches_config_1.css)({
    overflow: "hidden",
    height: "38px",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    outline: "none",
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: stitches_config_1.theme.colors.gray7,
    "&:hover": {
        borderColor: stitches_config_1.theme.colors.gray8,
    },
    "&:focus-within": {
        borderColor: stitches_config_1.theme.colors.blue9,
        boxShadowColor: stitches_config_1.theme.colors.focus,
    },
    width: "360px",
    borderRadius: stitches_config_1.theme.shape.borderRadius,
    boxShadow: stitches_config_1.theme.shadows.shadowInner,
    background: stitches_config_1.theme.colors.white,
    color: stitches_config_1.theme.colors.gray12,
    "&::placeholder": {
        color: stitches_config_1.theme.colors.gray11,
        opacity: 1,
    },
    fontWeight: 400,
    fontSize: 14,
    lineHeight: "20px",
    fontFamily: "Inter",
    "&:disabled": {
        opacity: 0.5,
        cursor: "not-allowed",
    },
    variants: {
        error: {
            true: {
                borderColor: stitches_config_1.theme.colors.red7,
                "&:hover": {
                    borderColor: stitches_config_1.theme.colors.red8,
                },
                "&:focus": {
                    borderColor: stitches_config_1.theme.colors.red9,
                    boxShadowColor: stitches_config_1.theme.colors.error,
                },
            },
            false: {},
        },
        fullWidth: {
            true: {
                width: "100%",
            },
        },
    },
});
var StyledInput = (0, react_1.styled)("input", {
    outline: "none",
    width: "100%",
    height: "100%",
    flex: 1,
    border: "none",
    padding: "8px 12px",
});
var StyledContainer = (0, react_1.styled)("div", StyledTexfieldInputCss);
var SuffixContainer = (0, react_1.styled)("div", {
    padding: "8px 12px",
    height: "100%",
    background: "$gray2",
    "& *": {
        color: "$gray11",
    },
    borderLeft: "1px solid $gray7",
});
var className = "textfield";
function Textfield(props) {
    var fullWidth = props.fullWidth, suffix = props.suffix, error = props.error, inputProps = __rest(props, ["fullWidth", "suffix", "error"]);
    return ((0, jsx_runtime_1.jsxs)(StyledContainer, __assign({ error: error, fullWidth: fullWidth }, { children: [(0, jsx_runtime_1.jsx)(StyledInput, __assign({}, inputProps, { onClick: function (e) {
                    e.stopPropagation();
                    if (props.onClick)
                        props.onClick(e);
                }, className: "".concat(className, " ").concat(props.className) })), suffix && ((0, jsx_runtime_1.jsx)(SuffixContainer, { children: (0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ variant: "text-sm" }, { children: suffix })) }))] })));
}
exports.Textfield = Textfield;
Textfield.toString = function () { return ".".concat(className); };
var StyledCurrencyField = (0, react_1.styled)(react_currency_input_field_1.default, StyledTexfieldInputCss);
function CurrencyField(props) {
    var _a, _b, _c;
    return ((0, jsx_runtime_1.jsx)(StyledCurrencyField, __assign({}, props, { prefix: (_a = props.prefix) !== null && _a !== void 0 ? _a : "$", decimalScale: (_b = props.decimalScale) !== null && _b !== void 0 ? _b : 2, placeholder: (_c = props.placeholder) !== null && _c !== void 0 ? _c : "$0.00", className: "".concat(className, " ").concat(props.className) })));
}
exports.CurrencyField = CurrencyField;
CurrencyField.toString = function () { return ".".concat(className); };
//# sourceMappingURL=Textfield.js.map